@if (channel) {
  <shared-modal [mobile]="sharedService.screenSize !== 'l'">
    <!-- header -->
    <h2 slot="header">Selecionar fluxo</h2>

    <!-- body -->
    @if (loading) {
      <div class="flex justify-center items-center p-4">
        <kor-spinner></kor-spinner>
      </div>
    } @else {
      <div class="flex flex-col gap-3">
        @if (flowListService.flows.length > 0) {
          @for (flow of flowListService.flows; track flow) {
            <kor-checkbox
              [disabled]="saving"
              [label]="flow.label"
              [active]="channel.activeFlow === flow.uid"
              (click)="
                $event.stopImmediatePropagation(); selectFlow(flow.uid!)
              ">
            </kor-checkbox>
          }
        } @else {
          <span>
            Nenhum fluxo registrado.
            <a
              href="https://blu.direct/admin/chat/flows"
              class="font-bold text-accent-600"
              >Registre um fluxo</a
            >.</span
          >
        }
      </div>
    }

    <!-- footer -->
    <button
      slot="footer"
      class="secondary"
      (click)="sharedService.closeModal(route)">
      Cancelar
    </button>
    <button slot="footer" [disabled]="loading || saving" (click)="save()">
      {{ saving ? 'Salvando...' : 'Confirmar' }}
    </button>
  </shared-modal>
}
